import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { api } from '../services/api';
import { toast } from 'sonner';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function GoogleAuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);
  const [status, setStatus] = useState('processing');
  const [errorMessage, setErrorMessage] = useState('');
  const [errorSubMessage, setErrorSubMessage] = useState('');

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          console.error('[GOOGLE AUTH] No session_id in URL');
          setStatus('error');
          toast.error('Erreur d\'authentification Google');
          setTimeout(() => navigate('/client'), 2000);
          return;
        }

        console.log('[GOOGLE AUTH] Processing session_id:', sessionId.substring(0, 10) + '...');

        // Call backend to process the session
        const result = await api.googleAuthCallback(sessionId);

        if (result.success && result.customer) {
          // Store session token in localStorage
          localStorage.setItem('clientSessionToken', result.sessionToken);
          localStorage.setItem('clientCustomer', JSON.stringify(result.customer));
          
          console.log('[GOOGLE AUTH] Success! Customer:', result.customer.name);
          setStatus('success');
          toast.success(`Bienvenue ${result.customer.name || ''} ! 🎉`);
          
          // Navigate to client portal with user data
          navigate('/client', { 
            state: { 
              user: result.customer,
              fromGoogleAuth: true 
            },
            replace: true 
          });
        } else {
          throw new Error('Réponse invalide du serveur');
        }
      } catch (error) {
        console.error('[GOOGLE AUTH] Error:', error);
        setStatus('error');
        
        // Message d'erreur spécifique pour les clients non enregistrés
        const errorMessage = error.response?.data?.detail || '';
        if (error.response?.status === 403 || errorMessage.includes('non associé') || errorMessage.includes('non enregistré')) {
          setErrorMessage('Ce compte Google n\'est pas associé à un client enregistré.');
          setErrorSubMessage('Rendez-vous en magasin pour créer votre compte fidélité !');
          toast.error('Compte non enregistré');
        } else {
          setErrorMessage('Erreur de connexion');
          setErrorSubMessage('Veuillez réessayer');
          toast.error('Erreur de connexion Google');
        }
        
        setTimeout(() => navigate('/client'), 4000);
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div 
      className="min-h-screen overflow-x-hidden overflow-y-auto flex items-center justify-center"
      style={{
        background: 'linear-gradient(135deg, #0a0015 0%, #1a0033 50%, #0a0015 100%)',
      }}
    >
      <div className="text-center">
        {status === 'processing' && (
          <>
            <div className="w-16 h-16 border-4 border-cyan-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
            <p className="text-white text-xl">Connexion avec Google...</p>
            <p className="text-gray-400 text-sm mt-2">Veuillez patienter</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="text-6xl mb-4">✅</div>
            <p className="text-green-400 text-xl">Connexion réussie !</p>
            <p className="text-gray-400 text-sm mt-2">Redirection...</p>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="text-6xl mb-4">🚫</div>
            <p className="text-red-400 text-xl font-bold">{errorMessage || 'Erreur de connexion'}</p>
            <p className="text-gray-300 text-sm mt-2 max-w-xs mx-auto">{errorSubMessage || 'Retour à la page de connexion...'}</p>
            <div className="mt-6 p-4 rounded-xl bg-yellow-500/10 border border-yellow-500/30 max-w-sm mx-auto">
              <p className="text-yellow-400 text-sm">
                💡 <strong>Pas encore client ?</strong><br/>
                Rendez-vous au magasin pour créer votre carte de fidélité !
              </p>
              <p className="text-gray-400 text-xs mt-2">
                📍 138 Rue Arthur Lamendin, 62980 Vermelles
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
